import styled from "@emotion/styled";
import SearchIcon from "@mui/icons-material/Search";
import { Box, Button, IconButton, Paper } from "@mui/material";
import { HHNTheme } from "hhn-commons";
import { shouldForwardProp } from "./Common.style";

export const SearchWrapper = styled(Box)`
  padding-bottom: 10px;
`;

export const SearchContainer = styled(Paper)`
  padding: 2px 7px;
  display: flex;
  align-items: center;
`;

export const IconSearch = styled(SearchIcon)`
  padding: 0;
  color: ${HHNTheme.common.black};
`;

export const FilterIconButton = styled(IconButton)`
  padding: 4px;
  margin: 2px;
  border-radius: 3px;
`;

type AdvanceSearchButtonType = {
  fullWidth: boolean;
};

export const AdvanceSearchButton = styled(Button, {
  shouldForwardProp: prop =>
    shouldForwardProp<AdvanceSearchButtonType>(["fullWidth"], prop),
})<AdvanceSearchButtonType>(({ fullWidth }) => ({
  margin: fullWidth ? "0 10px 10px 10px" : 0,
  border: fullWidth ? undefined : "none",
  textTransform: fullWidth ? "capitalize" : "none",
  fontSize: fullWidth ? 14 : 15,
  fontWeight: fullWidth ? 400 : 500,
  paddingLeft: fullWidth ? 15 : 8,
  "&:hover": {
    border: fullWidth ? undefined : "none",
    background: fullWidth ? undefined : "none",
  },
}));
